export const tip_data = [
  {
    main: `Be Clear and Concise`,
    content: `Keep it simple and to the point.`,
    example: `Example: "Repair Roads in Benin City"`,
  },
  {
    main: `Be Specific`,
    content: "Focus on the exact issue or solution.",
    example: `Example: "Fix Classrooms at Ugbowo Primary School"`,
  },
  {
    main: `Use Action Words`,
    content: `Make it clear what you want to happen.`,
    example: `Example: "Stop Illegal Dumping in Ovia River"`,
  },
  {
    main: `Appeal to Emotions`,
    content: `Evoke urgency or importance.`,
    example: `Example: "Save Our School from Closure!"`,
  },
  {
    main: `Target the Right Authority`,
    content: `Direct the title at the decision-makers.`,
    example: `Example: "Ask Edo State to Provide Clean Water for Ewu"`,
  },
];

export const tip_data_two = [
  {
    main: `Start with the Inident`,
    content: `Clearly explain what happen in the first sentence.`,
  },
  {
    main: `Provide Key Details`,
    content: "Include relevant facts and dates",
  },
  {
    main: `Explain the Impact`,
    content: `Show how the issue affects people or the environment.`,
  },
];

export const category_data = ["Accident"];
